/* import __COLOCATED_TEMPLATE__ from './invites-wrapper.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();